<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
    <h5 style="color:white; background:#112f4e;" class="px-3"><b>{{'MI_CIRCULAR'| translate}}</b>
    </h5>
    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
        <b>{{'THE_BUDGET_ESTIMATE'| translate}}<br>
            {{'OUT_OF_THE_ABOVE'| translate}}
            <br>
        </b>
    </p>
<!-- </div> -->